import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn } from '@angular/forms';
import format from 'date-fns/format';
import * as _ from 'lodash';
import { BACKWARD_YEAR_RANGE } from 'src/environments/environment';
import { SelectOption } from '../object/select-option.model';

@Injectable({
  providedIn: 'root'
})
export class DatesService {

  constructor() { }

  ToShortTimeString(value) {
    if (!value)
      return null
    const year = value.slice(0, 4)
    const month = value.slice(5, 7)
    const day = value.slice(8, 10)
    const date = new Date(Number(year), Number(month) - 1, Number(day))
    return format(date, "yyyy-MM-dd")
  }

  CurrentDateToShortTimeString(_format: string = 'yyyy-MM-dd'): string {
    const value = new Date()
    // console.log(value, value.getFullYear(), value.getMonth(), value.getDate())
    const year = value.getFullYear()
    const month = value.getMonth()
    const day = value.getDate()
    const date = new Date(Number(year), Number(month), Number(day))
    // console.log('DATE', format(date, _format))
    return format(date, _format)
  }

  DateNextDay(_format: string = 'yyyy-MM-dd'): string {
    const value = new Date()
    // console.log(value, value.getFullYear(), value.getMonth(), value.getDate())
    const year = value.getFullYear()
    const month = value.getMonth()
    const day = value.getDate() + 1
    const date = new Date(Number(year), Number(month), Number(day))
    // console.log('DATE', format(date, _format))
    return format(date, _format)
  }

  CurrentStartDateToShortTimeString(_format: string = 'yyyy-MM-dd'): string {
    const value = new Date()
    // console.log(value, value.getFullYear(), value.getMonth(), value.getDate())
    const year = value.getFullYear()
    const month = value.getMonth()
    const day = 1
    const date = new Date(Number(year), Number(month), Number(day))
    // console.log('DATE', format(date, _format))
    return format(date, _format)
  }

  CurrentStartDateToISO(date: Date): string {
    const pad = (n: number) => n < 10 ? '0' + n : n;
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    return `${year}-${month}-01T00:00`;
  }

  CurrentNowDateToISO(date: Date, maxTime: boolean): string {
    const pad = (n: number) => n < 10 ? '0' + n : n;
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = maxTime ? 23 : pad(date.getHours());
    const minutes = maxTime ? 59 : pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  /**
   * Combina la fecha del calendario (solo día) con la hora actual del equipo.
   * Enviar solo "yyyy-MM-dd" hace que muchos parsers usen medianoche UTC y la hora mostrada quede desfasada.
   */
  mergeFechaSeleccionadaConHoraActual(fechaSeleccionada: string | Date | null | undefined): string {
    const now = new Date();
    let y: number;
    let m: number;
    let d: number;
    if (fechaSeleccionada == null || fechaSeleccionada === '') {
      y = now.getFullYear();
      m = now.getMonth();
      d = now.getDate();
    } else if (typeof fechaSeleccionada === 'string') {
      const s = fechaSeleccionada.trim();
      if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) {
        y = Number(s.slice(0, 4));
        m = Number(s.slice(5, 7)) - 1;
        d = Number(s.slice(8, 10));
      } else {
        const parsed = new Date(s);
        if (!isNaN(parsed.getTime())) {
          y = parsed.getFullYear();
          m = parsed.getMonth();
          d = parsed.getDate();
        } else {
          y = now.getFullYear();
          m = now.getMonth();
          d = now.getDate();
        }
      }
    } else {
      y = fechaSeleccionada.getFullYear();
      m = fechaSeleccionada.getMonth();
      d = fechaSeleccionada.getDate();
    }
    const merged = new Date(y, m, d, now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    const pad = (n: number) => (n < 10 ? '0' + n : n);
    // Sin offset: el backend convierte Utc→Chile al grabar en timestamp sin zona (evita guardar 17:21 en vez de 14:21).
    return `${merged.getFullYear()}-${pad(merged.getMonth() + 1)}-${pad(merged.getDate())}T${pad(merged.getHours())}:${pad(merged.getMinutes())}:${pad(merged.getSeconds())}`;
  }

  DateNextDayToISO(date: Date): string {
    const pad = (n: number) => n < 10 ? '0' + n : n;
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate() + 1);
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  GetStartAndCurrentMonth(_format: string = 'yyyy-MM-dd'): { initDate: string, currentDate: string, DateNextDay: string, lastDate: string } {
    return {
      initDate: this.CurrentStartDateToShortTimeString(),
      currentDate: this.CurrentDateToShortTimeString(),
      DateNextDay: this.DateNextDay(),
      lastDate: this.CurrentLastDateToShortTimeString()
    }
  }

  CurrentLastDateToShortTimeString(_format: string = 'yyyy-MM-dd'): string {
    const value = new Date()
    // console.log(value, value.getFullYear(), value.getMonth(), value.getDate())
    const year = value.getFullYear()
    const month = value.getMonth()
    const lastDay = new Date(year, month + 1, 0); // El día 0 del mes siguiente es el último día del mes actual
    const date = new Date(Number(year), Number(month), lastDay.getDate()) // Corregido para usar lastDay.getDate()
    // console.log('DATE', format(date, _format))
    return format(date, _format)
  }

  GetStartAndCurrentMonthToISO(maxTime: boolean = false): { initDate: string, currentDate: string, DateNextDay: string } {
    const date = new Date();
    return {
      initDate: this.CurrentStartDateToISO(date),
      currentDate: this.CurrentNowDateToISO(date, maxTime),
      DateNextDay: this.DateNextDayToISO(date),
    }
  }

  /**
   * Valida que el rango entre fechas no supere el máximo permitido (p. ej. 31 días).
   * Permite exactamente 'range' días: 31 (meses de 31), 30 (abril, junio, etc.), 28/29 (febrero).
   * @param dateStart Fecha desde (incluida)
   * @param dateEnd Fecha hasta (incluida)
   * @param range Máximo de días permitidos (ej: 31)
   */
  validRangeDate(dateStart: string, dateEnd: string, range: number = 31): boolean {
    if (dateStart && dateEnd) {
      const fechaDesde = new Date(dateStart);
      const fechaHasta = new Date(dateEnd);
      const timeDiff = fechaHasta.getTime() - fechaDesde.getTime();
      const dayDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

      return dayDiff >= 0 && dayDiff <= range;
    }
    return true;
  }

  GetMonths(): Array<SelectOption> {
    return [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' },
    ]
  }

  GetCurrentMonths(order: 'asc' | 'desc'): Array<SelectOption> {
    let months = this.GetMonths()
    months = months.filter(month => month.value < (new Date()).getMonth() + 2)
    if (order === 'desc')
      return _.reverse(months)
    return months
  }

  GetLastYears(range: number = 5): Array<SelectOption> {
    const array: Array<SelectOption> = []
    const now = new Date()
    const end = now.getFullYear();
    for (let i = 0; i < range; i++)
      array.push({ value: end - i, label: (end - i).toString() })
    return array;
  }

  GetRangeYears(backward: number = BACKWARD_YEAR_RANGE, forward: number = 0): Array<SelectOption> {
    const array: Array<SelectOption> = []
    const currentYear = (new Date()).getFullYear();
    for (let i = currentYear - backward; i <= currentYear + forward; i++)
      array.unshift({ value: i, label: (i).toString() })
    return array;
  }

  GetMonthsRange(startMonth: number, startYear: number, count: number = 12): any[] {
    return [...Array(count).keys()].map(n => new Date(startYear, startMonth - 1 + n, 1))
  }

  formatShortMonthYear(date: Date): string {
    const months = this.GetMonths()
    return `${months[date.getMonth()].label.slice(0, 3)} ${date.getFullYear()}`
  }

  validarRangoFecha(nameControlDesde: string, nameControlHasta: string, rangeInDays: number = 30): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } | null => {
      const controls = group.controls;
      const ctrlFechaDesde = controls[nameControlDesde];
      const ctrlFechaHasta = controls[nameControlHasta];
      const fechaDesde = ctrlFechaDesde ? ctrlFechaDesde.value : null;
      const fechaHasta = ctrlFechaHasta ? ctrlFechaHasta.value : null;

      if (fechaDesde && fechaHasta) {
        const fechaDesdeDate = new Date(fechaDesde);
        const fechaHastaDate = new Date(fechaHasta);
        const diffTime = Math.abs(fechaHastaDate.getTime() - fechaDesdeDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > rangeInDays) {
          ctrlFechaDesde.setErrors({ ...(ctrlFechaDesde.errors || {}), rangeDate: true });
          ctrlFechaHasta.setErrors({ ...(ctrlFechaHasta.errors || {}), rangeDate: true });
          return { 'rangeDate': true };
        } else {
          if (ctrlFechaDesde.errors) {
            const { rangeDate, ...otherErrors } = ctrlFechaDesde.errors;
            ctrlFechaDesde.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
          }
          if (ctrlFechaHasta.errors) {
            const { rangeDate, ...otherErrors } = ctrlFechaHasta.errors;
            ctrlFechaHasta.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
          }
        }
      } else {
        if (ctrlFechaDesde && ctrlFechaDesde.errors) {
          const { rangeDate, ...otherErrors } = ctrlFechaDesde.errors;
          ctrlFechaDesde.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
        }
        if (ctrlFechaHasta && ctrlFechaHasta.errors) {
          const { rangeDate, ...otherErrors } = ctrlFechaHasta.errors;
          ctrlFechaHasta.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
        }
      }
      return null;
    };
  }

  getDateNowConsole(): string {
    return new Date().toLocaleDateString('es-CL', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }

}
